import { Directive, DirectiveBinding, nextTick } from 'vue';

//触底加载钩子
const loadMore = {
  beforeMount(el, binding) {
    const selectDom = (document.querySelector(".more_select_dropdown")).querySelector(".el-select-dropdown .el-select-dropdown__wrap");
    function loadMores() {
      const Condition = selectDom.scrollHeight - selectDom.scrollTop <= selectDom.clientHeight;
      if(Condition) {
        binding.value && binding.value()
      }
    }
    el.selectDomInfo = selectDom
    el.userLoadMore = loadMores
    nextTick(() => {
      selectDom?.addEventListener('scroll', loadMores)
    })
  },
  beforeUnmount(el) {
    if (el.userLoadMore) {
      el.selectDomInfo.removeEventListener('scroll', el.userLoadMore)
      delete el.selectDomInfo
      delete el.userLoadMore
    }
  }
}

export default loadMore
